module.exports = __webpack_public_path__ + "static/p2-612394b9f61500744798d9df2a9b92d9.png";